<template>
  <el-container class="index-con">
    <!-- <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside> -->
    <el-container class="main-con">
      <!-- <el-header class="index-header">
        <navcon></navcon>
      </el-header> -->
      <el-main clss="index-main">
        <router-view></router-view>
       <!-- <div class="footer">技术支持©甘肃诚创电子科技有限公司</div> -->
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
import {checklogin} from '../api/userMG'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false
    }
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {},
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })
  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    /* checklogin().then(res => {
        if(res.code != 0){
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'error',
              message: res.msg
            })
          }, 100)
        }
      }
    ) */
  }

}
</script>
<style >
.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
  overflow: hidden;
}
.index-header,
.index-main {
  padding: 0px;
  border-left: 2px solid #333;
}
.el-main{background-color: #f3f3f3; padding:  0 0 0 0 !important;}
.footer{color:#666;font-size: 14px;text-align: center;position: fixed;
height: 30px;line-height: 20px;width: 100%;bottom: 0px;padding-top: 5px;}
</style>



// WEBPACK FOOTER //
// src/views/index.vue